import type { GetOrganizerServiceInfoQuery } from "../graphql/event.hooks";

import { useReactiveVar } from "@apollo/client";

import { SubscriptionPlanEnum } from "../constants";
import { BASE_URL } from "../constants/url";
import { currentUserVar } from "../graphql/globalVar/state";
import i18next from "../i18n";

const getAuthDetails = (data: GetOrganizerServiceInfoQuery | null) => ({
  activeSubscription: data?.activeSubscription ?? null,
  needVerifyEmail: data?.needVerifyEmail ?? null,
  email: data?.organizer?.email ?? "",
  subscriptionPlan: (data?.organizer?.subscription?.plan ??
    null) as SubscriptionPlanEnum | null,
});

export const hasCustomDomainAccess = (plan: SubscriptionPlanEnum | null) =>
  plan === SubscriptionPlanEnum.Business;

// Auth Service for handling user authentication
export const authService = {
  setUser: (data: GetOrganizerServiceInfoQuery) => {
    if (!data) return;
    currentUserVar({
      ...data,
    });
  },
  getUser: () => getAuthDetails(currentUserVar()),
  logout: () => {
    currentUserVar(null);
    const locale = i18next.language === "en" ? "" : `/${i18next.language}`;
    window.location.href = `${BASE_URL}${locale}/logout`;
  },
};

// Auth hook for handling user authentication
export const useAuthService = () => {
  const user = useReactiveVar(currentUserVar);
  return getAuthDetails(user);
};
